import type {FilterFormValues} from "./types";

export const FILTER_FORM_NAMES: Record<keyof FilterFormValues, string> = {
  operator: "operator",
  values: "values",
};